import { useState } from 'react';
import { Radio, RadioChangeEvent, Space } from 'antd';
import { useThemeContext } from '@/shared/theme';

const getBrowserTheme = () =>
  window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

export const Appearance = () => {
  const { theme, setTheme } = useThemeContext();

  const [selectedTheme, setSelectedTheme] = useState<
    'dark' | 'light' | 'system' | undefined
  >(theme);

  const handleThemeChange = (e: RadioChangeEvent) => {
    const value = e.target.value;
    setSelectedTheme(value);
    if (value === 'system') {
      setTheme(getBrowserTheme());
      return;
    }
    setTheme(value);
  };

  return (
    <Space style={{ marginBottom: 24 }}>
      Theme:
      <Radio.Group
        name="radiogroup"
        value={selectedTheme}
        buttonStyle="solid"
        onChange={handleThemeChange}
      >
        <Radio.Button value="light">Light</Radio.Button>
        <Radio.Button value="dark">Dark</Radio.Button>
        <Radio.Button value="system">System</Radio.Button>
      </Radio.Group>
    </Space>
  );
};
